var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "menu-left",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M3,8.992A1.492,1.492,0,0,1,4.492,7.5H16.507a1.493,1.493,0,1,1,0,2.985H4.492A1.492,1.492,0,0,1,3,8.992Z",
    transform: "translate(-2.999 -7.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M3,18a1.492,1.492,0,0,1,1.492-1.492H31.507a1.493,1.493,0,0,1,0,2.985H4.492A1.492,1.492,0,0,1,3,18Z",
    transform: "translate(-2.999 -7.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M4.492,25.515a1.492,1.492,0,1,0,0,2.985H22.507a1.493,1.493,0,0,0,0-2.985Z",
    transform: "translate(-2.999 -7.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLeft);
export default __webpack_public_path__ + "static/media/menu-left.b67bda26bd5b16de71eeef58af3376eb.svg";
export { ForwardRef as ReactComponent };